import { Button } from "@sellar-io/components";
import { useEffect } from "react";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../components/modal/Dialog";
import { OrderItemForm } from "../forms/OrderItemForm";
import {
  OrderOnBehalfOfOrderItemType,
  useOrderOnBehalfOfContext,
} from "../OrderOnBehalfOf.shared";

export const EditOrderItemDialog = ({
  orderItem,
  onUpdate,
  onDelete,
  onDismiss,
}: {
  orderItem: OrderOnBehalfOfOrderItemType;
  onUpdate: (orderItem: OrderOnBehalfOfOrderItemType) => void;
  onDelete: () => void;
  onDismiss: () => void;
}) => {
  const { editingProductId } = useOrderOnBehalfOfContext();

  const active = editingProductId === orderItem.Product.id;

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <EditOrderItemDialogContent
        orderItem={orderItem}
        onUpdate={onUpdate}
        onDelete={onDelete}
      />
    </Dialog>
  );
};

export const EditOrderItemDialogContent = ({
  orderItem,
  onUpdate,
  onDelete,
}: {
  orderItem: OrderOnBehalfOfOrderItemType;
  onUpdate: (orderItem: OrderOnBehalfOfOrderItemType) => void;
  onDelete: () => void;
}) => {
  const { setEditingProductId } = useOrderOnBehalfOfContext();

  useEffect(() => {
    setEditingProductId(orderItem.Product.id);
    return () => {
      setEditingProductId(undefined);
    };
  }, [orderItem.Product.id, setEditingProductId]);

  return (
    <div>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => setEditingProductId(undefined)}
        title={"Edit line item"}
      />
      <DialogContent>
        <OrderItemForm
          orderItem={orderItem}
          product={orderItem.Product}
          onSubmit={onUpdate}
        >
          <div className={"flex w-full gap-2 *:grow"}>
            <Button color={"red"} onClick={onDelete}>
              Remove
            </Button>
            <Button type={"submit"}>Update</Button>
          </div>
        </OrderItemForm>
      </DialogContent>
    </div>
  );
};
